"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("./styles");
var HiLogo = function (_a) {
    var color = _a.color, width = _a.width, height = _a.height, commonProps = __rest(_a, ["color", "width", "height"]);
    return (react_1.default.createElement(styles_1.Wrapper, __assign({ "data-component-name": "HiLogo" }, commonProps, { "$width": width, "$height": height, "$color": color }),
        react_1.default.createElement("path", { d: "M8 0C3.58172 0 0 3.58172 0 8V24C0 28.4183 3.58172 32 8 32H24C28.4183 32 32 28.4183 32 24V8C32 3.58172 28.4183 0 24 0H8ZM7.46667 6.73326L9.89473 17.0827L11.8318 16.6097L10.7928 12.1815L14.8342 11.1945L15.873 15.6225L17.81 15.1495L15.3819 4.8L13.4449 5.27313L14.4419 9.52281L10.4008 10.5099L9.40375 6.26013L7.46667 6.73326ZM23.6281 26.0277L8.90355 27.426L8.75965 25.592L23.4844 24.1937L23.6281 26.0277ZM24.4785 11.0536C24.2738 11.7504 23.5555 12.1619 22.8743 11.973C22.1931 11.7839 21.8067 11.0659 22.0115 10.3692C22.2163 9.67239 22.9344 9.26087 23.6157 9.44979C24.297 9.63882 24.6832 10.3569 24.4785 11.0536ZM21.3747 14.5342L19.8554 19.8783L21.6471 20.4056L23.1663 15.0616L21.3747 14.5342Z", fillRule: "evenodd", clipRule: "evenodd", fill: "currentColor" })));
};
exports.default = HiLogo;
